import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'TRAINING_UPDATE',
    smsDelete : 'TRAINING_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        training: [],
        training_detail: {},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        trainingLoading: false,
        trainingError: false,
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_TRAINING(state, training) {
            state.training = training;
        },

        SET_TRAINING_DETAIL(state, detail) {
            state.training_detail = detail;
        },

        TRAINING_LOADING (state, loading) {
            state.trainingLoading = loading;
        },

        TRAINING_ERROR (state, hasError) {
            state.trainingError = hasError;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        //Training
        async addTraining ({commit, dispatch}, payload) {
            commit('TRAINING_LOADING', true);
            commit('TRAINING_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.create_training, payload.training, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTraining')
                return response

            } catch (e) {
                commit('TRAINING_ERROR', true);
            } finally {
                commit('TRAINING_LOADING', false);
            }
        },

        async fetchTrainingDetail ({ commit },payload) {
            commit('TRAINING_LOADING', true);
            commit('TRAINING_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_training_details + payload, config);
                let response = result.data.data
                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('TRAINING_ERROR', true);
            } finally {
                commit('TRAINING_LOADING', false);
            }
        },

        async fetchTraining ({ commit }) {
            commit('TRAINING_LOADING', true);
            commit('TRAINING_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.training_list, config);
                let response = result.data
                commit('SET_TRAINING', response.data);

            } catch(error) {
                commit('TRAINING_ERROR', true);
            } finally {
                commit('TRAINING_LOADING', false);
            }
        },
    
        async updateTraining ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_training+payload.id, payload.training, config).then(result=>{
                    let data = result.data
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTraining')
                return response

            } catch (e) {
                commit('TRAINING_ERROR', true);
            } finally {
                commit('TRAINING_LOADING', false);
            }
        },

        async deleteTraining({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.training_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchTraining')
            return response
        }
    },

    getters: {}
}
